// extracted by mini-css-extract-plugin
module.exports = {"btn":"FavoriteButton_btn__1b9FI","active":"FavoriteButton_active__zEUJQ","svg":"FavoriteButton_svg__2zQtD"};